export const MODAL_ANIMATION_LENGTH = 1000;
